import { render, staticRenderFns } from "./JobPost.vue?vue&type=template&id=c0dc8628&"
import script from "./JobPost.vue?vue&type=script&lang=js&"
export * from "./JobPost.vue?vue&type=script&lang=js&"
import style0 from "./JobPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports